/**
 * 数据看板下的设备监控
 * date:2022 06 24
 * author：brian
 */
import httpRequest from '@/utils/request.js';

/**获取数据看板设备列表 */
export const monitorLst = (params = {}) => httpRequest.httpGet({
    url: '/service/device/monitor/lst', params: {
        ...params
    }
});
/**获取 设备列表详细信息 */
export const monitorGetDeviceList = (params = {}) => httpRequest.httpGet({
    url: '/service/device/monitor/getDeviceList', params: {
        ...params
    }
});
/**获取 设备详细信息接口 */
export const monitorGetDeviceInfo = (params = {}) => httpRequest.httpGet({
    url: '/service/device/monitor/getDeviceInfo', params: {
        ...params
    }
});
/**获取 批量勾线获取设备显示信息 */
export const monitorGetBatchDeviceInfo = (data = {}) => httpRequest.httpPost('/service/device/monitor/getBatchDeviceInfo', data);
/**保存数据看板内容 */
export const monitorAdd = (data) => httpRequest.httpPost('/service/device/monitor/save', data);


// ----------------- function:数据分析 date:2022 06 30 -------------------------

/**获取设备数据分析分页列表接口 */
export const analyseList = (params = {}, type) => httpRequest.httpGet({
    url: '/service/device/analyse/lst/' + type, params: {
        ...params
    }
});
/**获取设备设置 分析数据 */
export const analyseGetDataAnalysis = (params = {}, type) => httpRequest.httpGet({
    url: '/service/device/analyse/getDataAnalysis/' + type, params: {
        ...params
    }
});
/**获取设备保存列表接口 */
export const analyseGetDeviceList = (type) => httpRequest.httpGet({ url: '/service/device/analyse/getDeviceList/' + type });
/**保存 数据分析设备*/
export const analyseSaveDeviceList = (data) => httpRequest.httpPost('/service/device/analyse/saveDeviceList',data);
/**保存设备数据分析设置*/
export const analyseSaveSetting = (data) => httpRequest.httpPost('/service/device/analyse/saveSetting',data);